export default {
  namespaced: true,
  brigades: {
    title: "Brigade | Brigades",
    name: "Name",
    division: "Division",
    floor: "Floor",
    type_category: "Category",
    number_floors: "Number of Floors",
    capacity: "Capacity",
    role: "Role",
    user: "User",
    filter_by_floor: "Filter by Floor",
    filter_by_role: "Filter by Role",
    filter_by_search: "Search",
    filter_by_search_placeholder: "User or SOEID",
    status: "Status",
    courses_uploaded: "Courses uploaded",
    courses_skipped: "Courses skipped",
  },
};
